import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Observable } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Feature } from './Feature';
import { environment } from '../../../../environments/environment'

@Injectable()
export class FeaturesService {
  private featureURL = `${environment.defaultURL}/V2/feature/`;
  constructor(private http: HttpClient) {
  }

  getFeature(): Observable<Feature>{
    const httpOptions = { headers : new HttpHeaders({ 'Content-Type': 'application/json' })};
    let url = `${this.featureURL}`;
    return this.http.get<Feature>(url, httpOptions);
  }
}
